import React, { useState } from "react";
import {
  IconButton,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
  useToast,
  Button,
  Tooltip,
} from "@chakra-ui/react";
import { MdOutlineDelete } from "react-icons/md";
import { eliminarMalla } from "../../helpers/api.helper";

const EliminarMalla = (props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();
  const [loading, setLoading] = useState(false);
  const { malla, fetchMallas, user } = props;

  const toast = useToast();

  const handleEliminarRegistro = async () => {
    setLoading(true);
    let res = await eliminarMalla({
      id: malla.id,
      usuarioDelete: user.username,
    });
    if (res.success) {
      toast({
        status: "success",
        isClosable: true,
        title: "Malla eliminada correctamente",
        duration: 3000,
      });
      fetchMallas();
      onClose();
    } else {
      return toast({
        title: "Error al eliminar malla",
        description: res.data,
        status: "error",
        isClosable: true,
        duration: 3000,
      });
    }
    setLoading(false);
  };

  return (
    <>
      <Tooltip label="Eliminar Malla">
        <IconButton
          variant="link"
          icon={<MdOutlineDelete fontSize="20px" />}
          onClick={onOpen}
          _hover={{ color: "brand.naranja" }}
        />
      </Tooltip>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        size="xl"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader
              color="brand.gris_primario"
              fontSize="lg"
              fontWeight="bold"
            >
              Eliminar Malla
            </AlertDialogHeader>

            <AlertDialogBody>
              ¿Estás seguro que desea eliminar la malla{" "}
              <strong>{malla.descripcion}</strong>?
              <br />
              Esta acción no se puede revertir.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} variant="link" onClick={onClose}>
                Cancelar
              </Button>
              <Button
                bg="brand.naranja"
                onClick={handleEliminarRegistro}
                ml={3}
                isDisabled={loading || user.idRol === "usuarioIT"}
                color="white"
              >
                Eliminar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default EliminarMalla;
